/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   7/16/21
 */

import React from "react";
import {CircularProgress, Stack, Typography} from "@mui/material";

export interface LoadingHeroProps {
	message?: string | null
	m?: number
}

export default function LoadingHero(props: LoadingHeroProps) {

	return (
		<Stack sx={{ m: props.m ?? 20 }} alignItems={"center"} spacing={1}>
			<CircularProgress size={40} />
			{props.message !== null &&
			<Typography>{props.message || "Loading, please wait..."}</Typography>}
		</Stack>
	);

}